import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      aiUser: state => state.auth.user,
    }),
    aiEnabled() {
      const professional = this.aiUser && this.aiUser.professional;
      return !professional || professional.aiEnabled !== false;
    },
  },
};
